import { NAlert, NModal, NText } from 'naive-ui';
import { defineComponent, onMounted, watch } from 'vue';
import { GuidedTourOverlay } from '../GuidedTour/GuidedTourOverlay';
import { useGuidedTourStore } from '../GuidedTour/guidedTourStore';
import { useTutorialStore } from './tutorialStore';
import './tutorial.scss';

/**
 * O que fica montado no shell do app por causa do tutorial: a faixa de aviso, o balão
 * do passo atual e o recado de encerramento por falha.
 *
 * Substitui o botão '?' que existia aqui. A ajuda deixou de ser algo que a pessoa
 * invoca de qualquer tela e passou a ser um tutorial que ela inicia no manual — foi
 * decisão de produto, e o que se perde é a ajuda no momento exato do aperto.
 */
export const TutorialHost = defineComponent({
	name: 'TutorialHost',

	setup() {
		const tutorial = useTutorialStore();
		const tour = useGuidedTourStore();

		// Quem está aprendendo dá F5 sem pensar, e perder o tutorial aí é justamente o
		// momento em que a pessoa desiste e liga para o suporte. Este host fica montado no
		// shell do app, então é daqui que a retomada tem de partir — e é ela que traz de
		// volta a faixa e o balão, junto com o portão.
		onMounted(() => void tutorial.restore());

		// O tour termina quando a pessoa conclui o último passo. Quem fecha o portão e
		// devolve a navegação é o tutorial, então ele precisa saber que acabou.
		watch(
			() => tour.isRunning,
			(running) => {
				if (!running && tutorial.running) void tutorial.finish();
			},
		);

		return { tutorial, tour };
	},

	render() {
		return (
			<>
				{this.tutorial.running && (
					<div class="tut-banner">
						<NText strong>MODO TUTORIAL</NText>
						<span class="tut-banner__sep">·</span>
						<span>nada do que você fizer aqui é real</span>
					</div>
				)}

				{this.tour.isRunning && <GuidedTourOverlay />}

				<NModal
					show={!!this.tutorial.failure}
					preset="card"
					title="O tutorial parou aqui"
					style="max-width: 460px;"
					onUpdateShow={(value: boolean) => !value && this.tutorial.dismissFailure()}
				>
					<NAlert type="warning" bordered={false}>
						Tive um problema no treinamento e o encerrei por segurança. Você pode continuar
						usando o app normalmente — nada foi criado nem alterado.
					</NAlert>

					<NText depth={3} style="font-size: 12px; display: block; margin-top: 12px;">
						{this.tutorial.failure}
					</NText>
				</NModal>
			</>
		);
	},
});

export default TutorialHost;
